import { create } from "zustand";
import { postQueryRequest } from "../api/query";


export const useQueryStore = create((set, get) => ({
    loading: false,

    postQuery: async (formData) => {
        try {
            const res = await postQueryRequest(formData)
        } catch (error) {
            set({ loading: false });
            throw error;
        }
    }
}))